import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "admin-container" }
const _hoisted_2 = { class: "menu" }
const _hoisted_3 = { class: "logged-in-user" }
const _hoisted_4 = ["src", "alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Footer = _resolveComponent("Footer")!
  const _component_MobileFooter = _resolveComponent("MobileFooter")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          src: _ctx.authUser.avatar,
          alt: _ctx.authUser.name
        }, null, 8, _hoisted_4),
        _createVNode(_component_Dropdown, { options: _ctx.userOptions }, {
          default: _withCtx(() => [
            _createElementVNode("span", null, _toDisplayString(_ctx.authUser.name), 1)
          ]),
          _: 1
        }, 8, ["options"])
      ])
    ]),
    _renderSlot(_ctx.$slots, "default", {}, undefined, true),
    (!_ctx.isMobile && !_ctx.isTablet)
      ? (_openBlock(), _createBlock(_component_Footer, { key: 0 }))
      : (_openBlock(), _createBlock(_component_MobileFooter, { key: 1 }))
  ]))
}